import React from 'react';
import styled from '@emotion/styled';
import { PhoneFilledIcon } from '../../sections/header/header-mobile-old/Icons/PhoneFilledIcon';

export const CallUsButton = styled.a`
    width: 100%;
    padding: 8px 16px;
    background: linear-gradient(
        to right,
        ${({ theme }) => theme.colorsUnifications.golden[100]},
        ${({ theme }) => theme.colorsUnifications.yellowSea[100]}
    );
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    align-items: center;
    color: ${({ theme }) => theme.text.color.primary};
    display: flex;
    border: 1px solid ${({ theme }) => theme.colorsUnifications.yellowSea[100]};
    max-width: 400px;
    text-decoration: none;

    &:hover,
    &:active,
    &:visited {
        color: ${({ theme }) => theme.text.color.primary};
        text-decoration: none;
    }
`;

export const Container = styled.div`
    width: 100%;
    padding: 0 16px;
    position: fixed;
    z-index: 9;
    bottom: 16px;
    display: flex;
    justify-content: center;

    ${({ theme }) => theme.media.mdAndUp} {
        display: none;
    }
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    align-items: center;
`;

export const CallUsTitle = styled.h4`
    font-size: 17px;
    font-weight: 700;
    margin: 0;
    text-align: center;
`;

export const CallUsNumber = styled.span`
    font-size: 12px;
`;

export const StyledPhoneIcon = styled(PhoneFilledIcon)`
    height: 24px;
    width: 24px;
    flex-shrink: 0;
`;
